import validaData from '@/utils/validacoes/validaData';

export default function validaDataNascimento(data) {
  if (!validaData(data)) {
    return false;
  }

  const [ano] = data.split('-');
  const anoAtual = (new Date()).getFullYear();
  const anosAtras = anoAtual - ano;

  return anosAtras <= 150;
}
